module.exports = __webpack_public_path__ + "static/img/1.4872b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/1.png
// module id = TUC0
// module chunks = 0